import { useI18n } from 'hooks/useI18n';
import * as S from './LandingSeptiembre25.styled';
import { getPublicPath } from 'utils/paths';
import { FeaturedVideo } from './Videos';
import HtmlTrans from 'components/shared/HtmlTrans';
/* import { AccordionItem } from './Accordion'; */
import React from 'react';
import { ServiceLead } from 'services/service.lead';
import { useToasts } from 'hooks/useToasts';
import { getErrorMessage } from 'utils/errors';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';

const SuscribeSection: React.FC = () => {
  const { t } = useI18n('landing-septiembre25');
  const { addErrorToast } = useToasts();
  const { executeRecaptcha } = useGoogleReCaptcha();
  const [hasSubscribed, setHasSuscribed] = React.useState(false);
  const [email, setEmail] = React.useState('');

  const onSubmit = React.useCallback(
    async (data: { email: string }) => {
      try {
        if (!executeRecaptcha) {
          console.error('Recaptcha not available');
          return;
        }

        const recaptchaToken = await executeRecaptcha('septiembre25_submit');

        await ServiceLead.create({
          clientName: 'unknown',
          contactEmail: data.email,
          companyName: 'unknown',
          landingName: 'septiembre25',
          createPipedriveLead: false,
          isMql: false,
          isSubscribeToNewsletter: false,
          recaptchaToken
        });

        setHasSuscribed(true);
      } catch (ex) {
        console.error(
          `[elsindromedeseptiembrePage] Could not send form data. ${ex}`
        );

        addErrorToast(
          t('subscribe.submit-error', {
            error: getErrorMessage(ex)
          })
        );
      }
    },
    [addErrorToast, t, executeRecaptcha]
  );

  return (
    <S.Subscribe>
      <div className="description">
        <HtmlTrans ns="landing-septiembre25" i18nKey="subscribe.desc" />
      </div>
      {hasSubscribed ? (
        <HtmlTrans ns="landing-septiembre25" i18nKey="subscribe.confirmation" />
      ) : (
        <div className="form-content">
          <label htmlFor="emailInput" className="label">
            {t('subscribe.emailLabel')}
          </label>
          <div className="input-group">
            <input
              id="emailInput"
              className="input"
              type="email"
              placeholder={t('subscribe.emailPlaceholder')}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <button
              className="button"
              onClick={() => onSubmit({ email })}
              disabled={!email}
            >
              {t('subscribe.button')}
            </button>
          </div>
        </div>
      )}
      <div className="socials">
        <div className="text">{t('subscribe.socials.desc')}</div>
        <div className="icons">
          <a
            href={t('subscribe.socials.linkedin')}
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={getPublicPath('/images/septiembre25/linkedIn_logo.png')}
              alt="LinkedIn"
            />
          </a>
          <a
            href={t('subscribe.socials.x')}
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={getPublicPath('/images/septiembre25/x_logo.png')}
              alt="X"
            />
          </a>
        </div>
      </div>
    </S.Subscribe>
  );
};

export const LandingSeptiembre25: React.FC = () => {
  const { t } = useI18n('landing-septiembre25');

  return (
    <S.Wrapper>
      <S.Intro>
        <img
          className="logo"
          src={getPublicPath('/images/septiembre25/header.png')}
          alt=""
          role="presentation"
        />

        <div className="folder-container">
          <img
            className="folder"
            src={getPublicPath('/images/septiembre25/folder.png')}
            alt=""
            role="presentation"
          />
          <span className="tab-1">{t('folder.tab1')}</span>
          <span className="tab-2">{t('folder.tab2')}</span>
          <span className="tab-3">{t('folder.tab3')}</span>

          <img
            className="text"
            src={getPublicPath('/images/septiembre25/text-intro-title.png')}
            alt=""
            role="presentation"
          />
          <img
            className="cursor"
            src={getPublicPath('/images/septiembre25/cursor.png')}
            alt=""
            role="presentation"
          />
        </div>
      </S.Intro>
      <SuscribeSection />
      <S.Description>
        <>
          <HtmlTrans ns="landing-septiembre25" i18nKey="desc" />
        </>
        <img
          src={getPublicPath('/images/septiembre25/arrow.png')}
          alt=""
          role="presentation"
        />
      </S.Description>

      {/* <AccordionItem
        title={t('act1.title')}
        color={'#94A7B1'}
        content={t('act1.content')}
      />
      <AccordionItem
        title={t('act2.title')}
        color={'#84441C'}
        content={t('act2.content')}
      />
      <AccordionItem
        title={t('act3.title')}
        color={'#2E6BA4'}
        content={t('act3.content')}
      /> */}

      <S.Cows>
        <div className="cowsText">
          <HtmlTrans ns="landing-septiembre25" i18nKey="cows.desc" />
        </div>
      </S.Cows>

      <S.FeaturedVideos>
        <div className="featuredVideosDesc">
          <HtmlTrans ns="landing-septiembre25" i18nKey="videos.desc" />
        </div>
        <div className="videos">
          <FeaturedVideo videoId="1" />
          <FeaturedVideo videoId="2" />
          <FeaturedVideo videoId="3" />
        </div>
      </S.FeaturedVideos>

      {/* <S.Survey>
        <div className="title">
          <HtmlTrans ns="landing-septiembre25" i18nKey="survey.title" />
        </div>
        <div className="questions">
          <HtmlTrans ns="landing-septiembre25" i18nKey="survey.questions" />
        </div>
        <img
          className="surveyImage"
          src={getPublicPath('/images/septiembre25/hiking_image.png')}
          alt=""
          role="presentation"
        />
      </S.Survey> */}

      <SuscribeSection />

      <S.UfoFooter>
        <div className="topText">
          <HtmlTrans ns="landing-septiembre25" i18nKey="footer.topText" />
        </div>

        <div className="beamText">
          <HtmlTrans ns="landing-septiembre25" i18nKey="footer.beamText" />
        </div>

        <img
          className="logo"
          src={getPublicPath('/images/septiembre25/footer.png')}
          alt={'Una campaña de Manfred'}
        />
      </S.UfoFooter>
    </S.Wrapper>
  );
};
